import { IAllIssue, IUniqueIssue } from '../types/IssuesTypes';

export const ALL_ISSUES_MOCK_DATA: IAllIssue[] = [
	{
		id: '1',
		issueType: 'Interactable Role',
		severity: 'High',
		pageTitle: 'Home Page',
		pageUrl: 'https://example.com/',
		foundBy: 'Web SDK',
		sessionOrTest: 'Test Case 1',
		user: 'John Doe'
	},
	{
		id: '2',
		issueType: 'Keyboard Accessible',
		severity: 'SERIOUS',
		pageTitle: 'Login Page',
		pageUrl: 'https://example.com/login',
		foundBy: 'WFA',
		sessionOrTest: 'Session A',
		user: 'Jane Smith'
	},
	{
		id: '3',
		issueType: 'Alt Text',
		severity: 'Low',
		pageTitle: 'Product Page',
		pageUrl: 'https://example.com/products/1',
		foundBy: 'Web SDK',
		sessionOrTest: 'Test Case 2',
		user: 'John Doe'
	},
	{
		id: '4',
		issueType: 'Contrast',
		severity: 'MINOR',
		pageTitle: 'Dashboard',
		pageUrl: 'https://example.com/dashboard',
		foundBy: 'WFA',
		sessionOrTest: 'Session B',
		user: 'Jane Smith'
	},
	{
		id: '5',
		issueType: 'Focus Order',
		severity: 'MODERATE',
		pageTitle: 'Home Page',
		pageUrl: 'https://example.com/',
		foundBy: 'Web SDK',
		sessionOrTest: 'Test Case 1',
		user: 'John Doe'
	},
	{
		id: '6',
		issueType: 'Semantic HTML',
		severity: 'BEST_PRACTICE',
		pageTitle: 'Login Page',
		pageUrl: 'https://example.com/login',
		foundBy: 'WFA',
		sessionOrTest: 'Session A',
		user: 'Jane Smith'
	},
	{
		id: '7',
		issueType: 'Machine Learning Recommendation',
		severity: 'NEEDS_REVIEW',
		pageTitle: 'Product Page',
		pageUrl: 'https://example.com/products/1',
		foundBy: 'Web SDK',
		sessionOrTest: 'Test Case 2',
		user: 'John Doe'
	}
];

export const UNIQUE_ISSUES_MOCK_DATA: IUniqueIssue[] = [
	{
		id: 'u1',
		issueType: 'Interactable Role',
		severity: 'Critical',
		pageTitle: 'Home Page',
		pageUrl: 'https://example.com/',
		firstSeen: '2025-12-01T10:00:00Z',
		lastSeen: '2026-01-15T15:30:00Z'
	},
	{
		id: 'u2',
		issueType: 'Keyboard Accessible',
		severity: 'Serious',
		pageTitle: 'Login Page',
		pageUrl: 'https://example.com/login',
		firstSeen: '2025-11-20T09:00:00Z',
		lastSeen: '2026-01-10T11:20:00Z'
	},
	{
		id: 'u3',
		issueType: 'Alt Text',
		severity: 'Minor',
		pageTitle: 'Product Page',
		pageUrl: 'https://example.com/products/1',
		firstSeen: '2025-12-05T14:00:00Z',
		lastSeen: '2026-01-18T09:45:00Z'
	}
];
